module.exports = __webpack_public_path__ + "img/empty2.ce587005.webp";